var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgArrowRight(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 15,
    height: 11,
    viewBox: "0 0 15 11",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "arrow_right_alt_FILL0_wght300_GRAD0_opsz48",
    d: "M17.9,23.873a.625.625,0,0,1-.186-.417.462.462,0,0,1,.161-.392l3.868-3.945H9.17a.549.549,0,0,1-.409-.164.571.571,0,0,1-.161-.417.529.529,0,0,1,.161-.4.573.573,0,0,1,.409-.152H21.74l-3.893-3.97a.529.529,0,0,1,.025-.784.533.533,0,0,1,.793,0l4.711,4.8a.771.771,0,0,1,.174.253.688.688,0,0,1,.05.253.756.756,0,0,1-.05.278.771.771,0,0,1-.174.253l-4.711,4.8a.466.466,0,0,1-.372.177A.541.541,0,0,1,17.9,23.873Z",
    transform: "translate(-8.6 -13.05)",
    fill: "#fff"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgArrowRight);
export default __webpack_public_path__ + "static/media/arrow-right.d069d9b170dfe0907f1e8d7403bfa87d.svg";
export { ForwardRef as ReactComponent };